import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Ghost = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 28C25.3 28 24.387 27.337 23.663 26.812C23.013 26.337 22.55 25.999 21.5 25.999C20.45 25.999 19.988 26.336 19.337 26.812C18.612 27.337 17.7 28 15.999 28C14.298 28 13.387 27.337 12.661 26.812C12.011 26.337 11.548 25.999 10.499 25.999C9.45002 25.999 8.98702 26.336 8.33702 26.812C7.61202 27.337 6.69902 28 4.99902 28C4.44902 28 3.99902 27.55 3.99902 27V16C3.99902 9.387 9.38702 4 15.999 4C22.611 4 27.999 9.387 27.999 16V27C27.999 27.55 27.549 28 26.999 28H27ZM10.5 24C12.2 24 13.113 24.663 13.838 25.188C14.488 25.663 14.951 26.001 16 26.001C17.049 26.001 17.512 25.664 18.163 25.188C18.888 24.663 19.8 24 21.5 24C23.2 24 24.113 24.663 24.837 25.188C25.237 25.476 25.562 25.713 26 25.851V16.001C26 10.489 21.512 6.001 16 6.001C10.488 6.001 6.00002 10.489 6.00002 16.001V25.864C6.43802 25.727 6.76302 25.489 7.16202 25.201C7.88702 24.663 8.79902 24.001 10.5 24.001V24Z" />
		<path d="M21 18C19.35 18 18 16.65 18 15C18 13.35 19.35 12 21 12C22.65 12 24 13.35 24 15C24 16.65 22.65 18 21 18ZM21 14C20.45 14 20 14.45 20 15C20 15.55 20.45 16 21 16C21.55 16 22 15.55 22 15C22 14.45 21.55 14 21 14Z" />
		<path d="M11 18C9.35 18 8 16.65 8 15C8 13.35 9.35 12 11 12C12.65 12 14 13.35 14 15C14 16.65 12.65 18 11 18ZM11 14C10.45 14 10 14.45 10 15C10 15.55 10.45 16 11 16C11.55 16 12 15.55 12 15C12 14.45 11.55 14 11 14Z" />
	</svg>
);

export default Ghost;
